export const isHomeDelivery = (fulfillmentMethod) => fulfillmentMethod === 'DeliverFromStore'
  || fulfillmentMethod === 'ShipToHome'
  || fulfillmentMethod === 'DirectDelivery';
